<template>
  <div class="flex flex-col h-full min-h-full">
    <public-announcement :is-fixed="true" />
    <invitation-notifications v-if="currentUser.id" />
    <div class="template-library__content-wrapper">
      <OnboardingV3BackArrow />
      <div class="relative flex w-full mb-4 border-b border-secondary-20">
        <page-breadcrumb
          category="workspace"
          text="Templates"
          :title="category.name || ' '"
          :noBorder="true"
          class="teamplate-detail-breadcrum"
        />
      </div>
      <CategoryList :category-id="category.id" />
      <div class="loading-category-detail" v-if="isLoading">
        <InlineLoader :additionalClasses="'-mt-8'" />
      </div>
      <div v-else-if="!isLoading && category.id && category.PresentationsCategories" class="template-category">
        <div class="label-template text-left">
          {{ category.PresentationsCategories.length }} templates
        </div>
        <TemplateCard
          class="mb-6"
          v-for="itemCategory in category.PresentationsCategories"
          :key="itemCategory.id"
          :presentation="itemCategory.Presentation"
        />
      </div>
    </div>
  </div>
</template>

<script>
// components
import {
  mapState,
} from 'vuex'
import PublicAnnouncement from '@/components-v2/common/global-notification/PublicAnnouncement.vue'
import InvitationNotifications from '@/components-v2/common/global-notification/InvitationNotifications.vue'
import PageBreadcrumb from '../common/page-breadcrumb/PageBreadcrumb.vue'
import OnboardingV3BackArrow from '@/components-v2/common/onboarding/OnboardingV3BackArrow.vue'
import TemplateCard from '@/components-v2/common/template-library/TemplateCard.vue'
import CategoryList from '@/components-v2/template/CategoryList.vue'
import InlineLoader from '@/components-v2/common/loading/InlineLoader.vue'

import CategoryApi from '@/api/category'
import EventBus from '@/eventBus'

export default {
  components: {
    PageBreadcrumb,
    PublicAnnouncement,
    InvitationNotifications,
    OnboardingV3BackArrow,
    TemplateCard,
    CategoryList,
    InlineLoader,
  },
  data() {
    return {
      isLoading: true,
      category: {},
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
      hasOnboardingV3: (state) => state.indicators.hasOnboardingV3,
    }),
  },
  watch: {
    '$route.params.id': function (newValue) {
      this.category = {
        id: parseInt(newValue, 10),
      }
      this.getCategoryDetail()
    },
  },
  created() {
    this.getCategoryDetail()
    EventBus.$on('update-template-category', () => {
      this.getCategoryDetail()
    })
  },
  destroyed() {
    EventBus.$off('update-template-category')
  },
  methods: {
    initLazyLoad() {
      if (this.imageObserver) {
        this.imageObserver.disconnect()
      }
      const imageContainers = Array.from(document.querySelectorAll('.template-thumbnail.has-thumbnail'))
      if ('IntersectionObserver' in window) {
        this.imageObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const image = entry.target.querySelector('.thumbnail-image-with-skeleton')
              image.src = image.dataset.src
              this.imageObserver.unobserve(image)
            }
          })
        })
        imageContainers.forEach((img) => this.imageObserver.observe(img))
      } else {
        imageContainers.forEach((container) => {
          const img = container.querySelector('.thumbnail-image-with-skeleton')
          img.src = img.dataset.src
        })
      }
    },
    async getCategoryDetail() {
      this.isLoading = true
      const res = await CategoryApi.getCategoryDetail(this.$route.params.id)
      this.isLoading = false
      this.category = res
      document.title = `${this.category.name} | AhaSlides`
      document.body.classList.remove('no-scroll')
      this.$nextTick(this.initLazyLoad)
    },
  },
}
</script>

<style lang="scss" scoped>
.template-library__content-wrapper {
  @apply relative flex flex-col h-full m-4 mt-6 md:px-6;
  .onboarding__arrow {
    @apply top-4 lg:-left-4 -left-8;
  }
  &::v-deep {
    .skeleton-loader {
      position: absolute;
      top: 0;
    }
  }
}
.label-template {
  font-size: 16px;
  color: #707070;
  margin-bottom: 16px;
}

@media (max-width: 768px) {
}

.teamplate-detail-breadcrum {
  min-height: 72px;
}

.loading-category-detail{
  min-height: 300px;
  margin-top: 100px;
}
</style>
